<footer>
	<stages-buttons-bottom [removeBoundaries]="removeMargin()">
		@if (hasCancelButton()) {
			<button class="button sm cancel" translate="cancel" (click)="close()"></button>
		}
		@for (button of buttons(); track button; let i = $index) {
			@if (button.visible!()) {
				<button
					(click)="button.click()"
					[class]="button.class"
					[translate]="button.translate"
					[disabled]="button.disabled!()"
					[tabindex]="i + tabIndexOffset()"
				></button>
			}
		}
		<ng-content></ng-content>
	</stages-buttons-bottom>
</footer>
